import styled from "styled-components";

export const IPhoneMockup = styled.div`
  /* Estilos para o mockup do iPhone, se necessário */
`;

// Estilos para o vídeo dentro do mockup
export const VideoWrapper = styled.div`
  position: relative;
  width: 100%; 
  .video {
    width: 100%;
    object-fit: cover;
  }
`;
